
// WGS84 UTM32
import url_grigliato_utm_4000_32632 from '@/assets/geojson/grigliato_utm_4000_32632.json?url'


let data = {
    "type": "FeatureCollection",
    "name": "grigliato_utm_4000_32632",
    "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::32632" } },
    "features": []
}

fetch(url_grigliato_utm_4000_32632).then(response => response.json()).then(result => { data.features = result.features })


const WGS84UTM32_to_UTM4k = function (xpoint, ypoint) {




    //  intersect every polygon in data
    // with xpoint, ypoint
    // return the first feature found

    // const data = {
    //     "type": "FeatureCollection",
    //     "name": "grigliato_utm_4000_32632",
    //     "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::32632" } },
    //     "features": [
    //         { "type": "Feature", "properties": { "id": 1, "slug": "4242" }, "geometry": { "type": "Polygon", "coordinates": [[[343918.002982466830872, 5043801.506597976200283], [343918.004579749074765, 5039801.536256193183362], [339918.034155304252636, 5039801.534643713384867], [339918.032517060579266, 5043801.504987068474293], [343918.002982466830872, 5043801.506597976200283]]] } },
    //         { "type": "Feature", "properties": { "id": 2, "slug": "4246" }, "geometry": { "type": "Polygon", "coordinates": [[[343918.001386747055221, 5047801.476980964653194], [343918.002982466830872, 5043801.506597976200283], [339918.032517060579266, 5043801.504987068474293], [339918.030880418897141, 5047801.475371633656323], [343918.001386747055221, 5047801.476980964653194]]] } },
    //     ]
    // }


    let feature = null
    for (let i = 0; i < data.features.length; i++) {
        feature = data.features[i];
        if (inside(feature.geometry.coordinates[0], [xpoint, ypoint])) {
            return feature.properties.slug
        }
    }
    return -1

} // end



function inside(vs, point) {
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
    
    var x = point[0], y = point[1];
    
    var inside = false;
    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0], yi = vs[i][1];
        var xj = vs[j][0], yj = vs[j][1];
        
        var intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    
    return inside;
};


// onst getIsPointInsidePolygon = (point: number[], vertices: number[][]) => {
//     const x = point[0]
//     const y = point[1]
    
//     let inside = false
//     for (let i = 0, j = vertices.length - 1; i < vertices.length; j = i++) {
//       const xi = vertices[i][0],
//         yi = vertices[i][1]
//       const xj = vertices[j][0],
//         yj = vertices[j][1]
    
//       const intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
//       if (intersect) inside = !inside
//     }
    
//     return inside
//     }

export { WGS84UTM32_to_UTM4k, }


